export default {
  title: "Bloco",
  title_3d: "Visualização 3D do bloco",
  title_video: "Vídeo",
  data_specs: 
  {
    title: 'Mídias',
      list : [
          {
              entity: "type",
              label: "Tipo",
              unit: "",
              unit_small: "",
            },
            {
                entity: "width",
                label: "Largura",
                unit: "metros",
                unit_small: "m",
            },
            {
                entity: "height",
                label: "Altura",
                unit: "metros",
                unit_small: "m",
            },
            {
                entity: "diameter",
                label: "Comprimento",
                unit: "metros",
                unit_small: "m",
            },
            {
                entity: "weight",
                label: "Peso",
                unit: "Toneladas",
                unit_small: "Ton",
            },
        ],
    },
  data_media: {
    title: 'Mídias',
    list: [
      {
        entity: "total_images",
        label: "Fotos para site",
      },
      {
        entity: "length_img_3d",
        label: "Fotos para 3D",
      },
      {
        entity: "video_label",
        label: "Vídeo",
      },
    ],
  },

  data_3d: {
    title: '3D',
    list: [
      {
        entity: "total_files",
        label: "Total de arquivos",
      },
      {
        entity: "model",
        label: "Pasta",
      },
      {
        entity: "label_obj",
        label: "Arquivo Obj",
      },
      {
        entity: "label_created",
        label: "Cadastrado em",
      },
    ],
  },
};
